<header class="header-wrap">
    <div class="left-logo-block">
        <button type="button" id="nav-toggle-btn" (click)="toggleSidebar()">
            <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 0H16V2H0V0ZM0 5H16V7H0V5ZM0 10H16V12H0V10Z" fill="black" />
            </svg>
        </button>
        <div class="head-logo">
            <img src="../../../assets/svgs/head-logo.svg">
        </div>
    </div>
          <div class="head-right-block">
            <div class="pending-jobs-btn" *ngIf="!isLoadingPendingJobs && pendingJobsCount > 0">
          <button type="button" (click)="openPendingJobsModal()" class="btn btn-warning">
            <i class="fa fa-clock-o"></i>
            <span class="job-count">{{ pendingJobsCount }}</span>
            Pending Jobs
          </button>
        </div>
            <div class="head-user-profile" [matMenuTriggerFor]="menu">
                <h4>{{full_name ? full_name : 'ToonSutra User'}}</h4>
                <span>{{email_address ? email_address : 'user@toonsutra.com'}}</span>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="chnagePassword()">
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M12.8033 2.1967C11.3867 0.780128 9.5033 0 7.5 0C3.41224 0 0 3.41224 0 7.5C0 11.5878 3.41224 15 7.5 15C11.5878 15 15 11.5878 15 7.5C15 5.49667 14.2199 3.61327 12.8033 2.1967ZM10.8376 9.8857L9.96023 8.07821L10.7657 7.68721L11.1978 8.5774L11.2187 8.49099C11.2974 8.16564 11.3374 7.83221 11.3374 7.5C11.3374 5.21567 9.50558 3.35721 7.25401 3.35721C5.00244 3.35721 3.17064 5.21567 3.17064 7.5C3.17064 9.77359 4.98506 11.6253 7.22208 11.6427V12.538C4.49154 12.5205 2.27529 10.2672 2.27529 7.5C2.27529 4.72196 4.50875 2.46183 7.25404 2.46183C9.99933 2.46183 12.2328 4.72196 12.2328 7.5C12.2328 7.86731 12.1926 8.23635 12.1133 8.59689L12.0976 8.66824L12.8419 8.23164L13.2949 9.00391L11.4669 10.0763C11.1939 10.3045 10.8574 10.0561 10.8376 9.8857Z"
                                fill="black" />
                        </svg>
                        Change Password
                    </button>
                </mat-menu>
            </div>

            <div class="sign-out mr-l20">
                <button type="button" (click)="logout()">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M18.7879 9.33707L15.2524 5.80156C15.1653 5.7145 15.062 5.64544 14.9482 5.59832C14.8345 5.55121 14.7126 5.52695 14.5895 5.52695C14.4663 5.52695 14.3444 5.55121 14.2307 5.59832C14.1169 5.64544 14.0136 5.7145 13.9265 5.80156C13.7507 5.97737 13.6519 6.21583 13.6519 6.46447C13.6519 6.71311 13.7507 6.95156 13.9265 7.12738L15.8617 9.0625H5.625C5.37636 9.0625 5.1379 9.16127 4.96209 9.33708C4.78627 9.5129 4.6875 9.75136 4.6875 10C4.6875 10.2486 4.78627 10.4871 4.96209 10.6629C5.1379 10.8387 5.37636 10.9375 5.625 10.9375H15.8617L13.9265 12.8726C13.7507 13.0484 13.6519 13.2869 13.6519 13.5355C13.6519 13.7842 13.7507 14.0226 13.9265 14.1985C14.1024 14.3743 14.3408 14.473 14.5895 14.473C14.8381 14.473 15.0766 14.3743 15.2524 14.1984L18.7879 10.6629C18.9637 10.4871 19.0625 10.2486 19.0625 9.99998C19.0625 9.75134 18.9637 9.51288 18.7879 9.33707Z"
                            fill="#2B2C36" />
                        <path
                            d="M11.875 15.3125C11.6264 15.3125 11.3879 15.4113 11.2121 15.5871C11.0363 15.7629 10.9375 16.0014 10.9375 16.25V17.1875H2.8125V2.8125H10.9375V3.75C10.9375 3.99864 11.0363 4.2371 11.2121 4.41291C11.3879 4.58873 11.6264 4.6875 11.875 4.6875C12.1236 4.6875 12.3621 4.58873 12.5379 4.41291C12.7137 4.2371 12.8125 3.99864 12.8125 3.75V2.5C12.8125 2.29481 12.7721 2.09163 12.6936 1.90206C12.615 1.71249 12.4999 1.54024 12.3549 1.39515C12.2098 1.25005 12.0375 1.13496 11.8479 1.05644C11.6584 0.977915 11.4552 0.9375 11.25 0.9375H2.5C2.0856 0.9375 1.68817 1.10212 1.39515 1.39515C1.10212 1.68817 0.9375 2.0856 0.9375 2.5V17.5C0.9375 17.9144 1.10212 18.3118 1.39515 18.6049C1.68817 18.8979 2.0856 19.0625 2.5 19.0625H11.25C11.4552 19.0625 11.6584 19.0221 11.8479 18.9436C12.0375 18.865 12.2098 18.7499 12.3549 18.6049C12.4999 18.4598 12.615 18.2875 12.6936 18.0979C12.7721 17.9084 12.8125 17.7052 12.8125 17.5V16.25C12.8125 16.0014 12.7137 15.7629 12.5379 15.5871C12.3621 15.4113 12.1236 15.3125 11.875 15.3125Z"
                            fill="#2B2C36" />
                    </svg>
                </button>
            </div>
        </div>
</header>

<!-- Pending Jobs Modal -->
<div class="pending-jobs-modal-overlay" *ngIf="showPendingJobsModal" (click)="closePendingJobsModal()">
    <div class="pending-jobs-modal" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h4><i class="fa fa-clock-o"></i> Pending Jobs ({{ pendingJobsCount }})</h4>
            <button class="close-modal-btn" (click)="closePendingJobsModal()">
                <i class="fa fa-times"></i>
            </button>
        </div>

        <div class="modal-content">
            <div class="loading-container" *ngIf="isLoadingPendingJobs">
                <div class="loading-spinner">
                    <i class="fa fa-spinner fa-spin"></i>
                    <p>Loading pending jobs...</p>
                </div>
            </div>

            <div class="jobs-table-container" *ngIf="!isLoadingPendingJobs && pendingJobs.length > 0">
                <table class="jobs-table">
                    <thead>
                        <tr>
                            <th>Execution Name</th>
                            <th>Job Type</th>
                            <th>Image ID</th>
                            <th>Chapter ID</th>
                            <th>Started At</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let job of pendingJobs">
                            <td>{{ job.execution_name }}</td>
                            <td>
                                <span class="job-type-badge" [class]="'job-type-' + job.job_data.job_type">
                                    {{ job.job_data.job_type }}
                                </span>
                            </td>
                            <td>{{ job.job_data.image_id || 'N/A' }}</td>
                            <td>{{ job.job_data.chapter_id || 'N/A' }}</td>
                            <td>{{ formatDate(job.job_data.started_at) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="no-jobs-message" *ngIf="!isLoadingPendingJobs && pendingJobs.length === 0">
                <div class="empty-state">
                    <i class="fa fa-check-circle"></i>
                    <h6>No Pending Jobs</h6>
                    <p>All jobs have been completed successfully!</p>
                </div>
            </div>
        </div>
    </div>
</div>
